(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORE_KEY = 'pp_wishlist';

    function getWishlist() {
      // Reuse the PDP helper when present so both surfaces share one source of truth.
      if (typeof window.ppGetWishlist === 'function') return window.ppGetWishlist();
      try {
        var raw = localStorage.getItem(STORE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(list) {
      if (typeof window.ppSaveWishlist === 'function') {
        window.ppSaveWishlist(list);
        return;
      }
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(list));
      } catch (e) {}
      window.dispatchEvent(
        new CustomEvent('pp:wishlist:updated', { detail: { count: list.length, list: list } })
      );
    }

    function indexOfId(list, id) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(id)) return i;
      }
      return -1;
    }

    function setActive(btn, active) {
      btn.classList.toggle('ashoo-wish-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    }

    window.ashooToggleWish = function (btn, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var product = {
        id: btn.getAttribute('data-product-id'),
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        url: btn.getAttribute('data-product-url'),
        image: btn.getAttribute('data-product-image'),
        price: btn.getAttribute('data-product-price')
      };

      var list = getWishlist();
      var idx = indexOfId(list, product.id);

      if (idx === -1) {
        list.push(product);
        setActive(btn, true);
      } else {
        list.splice(idx, 1);
        setActive(btn, false);
      }

      saveWishlist(list);
    };

    function syncAll() {
      var list = getWishlist();
      var buttons = document.querySelectorAll('.ashoo-wish-btn');
      for (var i = 0; i < buttons.length; i++) {
        var pid = buttons[i].getAttribute('data-product-id');
        setActive(buttons[i], indexOfId(list, pid) !== -1);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }

    // Keep cards in sync with the PDP and with each other after any toggle.
    window.addEventListener('pp:wishlist:updated', syncAll);

    // Re-apply state to cards injected by collection filtering / pagination (AJAX section renders).
    if (window.MutationObserver) {
      var pending = false;
      var observer = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          syncAll();
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
